<template>
  <div class="modal-popup">
    <div class="modal fade" id="cruiseRoomPopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="cruiseRoom != null">
          <div class="modal-header">
            <h5 class="modal-title title" v-if="cruiseRoom.id != null">Güncelle</h5>
            <h5 class="modal-title title" v-if="cruiseRoom.id == null">Yarat</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post" id="cruiseRoomDetail">
                <div class="row">
                  <div class="col-sm-4">
                    <base-edit-input
                        v-model="cruiseRoom.roomNumber"
                        :rules="'required'"
                        :type="'text'"
                        :label="'Oda Numarası'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-4">
                    <base-select-input
                        v-model="cruiseRoom.deckId"
                        :optionList="deckList"
                        :rules="'required'"
                        :label="'Güverte'">
                    </base-select-input>
                  </div>
                  <div class="col-sm-4">
                    <base-select-input
                        v-model="cruiseRoom.roomId"
                        :optionList="roomList"
                        :rules="'required'"
                        :label="'Oda'">
                    </base-select-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <base-edit-input
                        v-model="cruiseRoom.maxGuestCount"
                        :rules="'required|min_value:0'"
                        :type="'number'"
                        :label="'Maksimum misafir:'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-4">
                    <base-edit-input
                        v-model="cruiseRoom.maxAdultCount"
                        :rules="'required|min_value:0'"
                        :type="'number'"
                        :label="'Maksimum yetişkin:'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-4 d-flex justify-content-center align-self-center">
                    <div class="input-box">
                      <span class="mr-2">Ros</span>
                      <input class="m-auto" type="checkbox" v-model="cruiseRoom.ros">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <div class="row d-flex justify-content-center">
              <div class="input-box">
                <span class="mr-2">Create another</span>
                <input class="m-auto" type="checkbox" v-model="createAnother">
              </div>
            </div>
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Cancel</button>
            <button v-if="cruiseRoom.id != null" :class="{'disabled' : !formValid}" @click="update" type="button" class="theme-btn theme-btn-small">Güncelle</button>
            <button v-if="cruiseRoom.id == null" :class="{'disabled' : !formValid}" @click="create" type="button" class="theme-btn theme-btn-small">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from "../../common/UploadImage";
import BaseSelectInput from "../../base/BaseSelectInput";
import BaseEditInput from "../../base/BaseEditInput";
import validationFormUtils from "../../../util/validationFormUtils";
import messagePopupManager from "../../../util/messagePopupManager";


export default {
  name: "CruiseRoomDetail",
  components: {BaseEditInput, BaseSelectInput, UploadImage},
  data:function (){
    return{
      formValid:false,
      createAnother : false
    }
  },
  computed:{
    cruiseRoom:{
      get(){
        return this.$store.getters.getCruiseRoom;
      },
      set(value){
        return this.$store.commit("setCruiseRoom", value)
      }
    },
    deckList:{
      get(){
        return this.$store.getters.getDeckList;
      }
    },
    roomList:{
      get(){
        return this.$store.getters.getRoomList;
      }
    }
  },
  methods:{
    create(){
      if(this.formValid)
        this.$store.dispatch("createCruiseRoom",this.cruiseRoom).then(()=>{
          this.$store.dispatch("loadCruiseRoomList", this.$store.getters.getCruise.id);

          if(this.createAnother){
            let cruiseRoom = this.$store.getters.getCruiseRoom;
            cruiseRoom.id = null;
            cruiseRoom.roomNumber = null;
            this.$store.commit("setCruiseRoom",cruiseRoom);
          }else{
            $(".modal").modal('hide')
          }
        })
    },
    update(){
      if(this.formValid)
        this.$store.dispatch("updateCruiseRoom", this.cruiseRoom).then(()=>{
          messagePopupManager.showSuccess();
        });
    }
  },
  watch:{
    cruiseRoom:{
      deep: true,
      handler:function (){
        validationFormUtils.checkFormFields(this);
      }
    }
  },
}
</script>

<style scoped>

</style>